module.exports = __webpack_public_path__ + "static/media/logo-febracis.19f30ec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-febracis.png
// module id = 723
// module chunks = 0